import styled from 'styled-components';

export default styled.hr`
  border: 0;
  border-top: 2px solid #e8e8e8;
  width: 100%;
`;
